import flBusiness from '@framelink/flbusiness'
import {fieldtype} from 'utils/enums/fieldtype'
import {cards} from 'utils/helpers'
import route from 'utils/enums/route'
import environment from 'utils/enums/environment'

export const fetchInstances = () => flBusiness.Auth.getInstances()

export const getDefaultInstance = () => flBusiness.Auth.getDefaultInstance()

export const fetchLogin = ({username, password, instance}) => flBusiness.Auth.login(username, password, instance)

export const fetchRegistration = ({newusername, newpassword, instance}) => flBusiness.Auth.register(newusername, newpassword, instance)

export const fetchAutologin = () => flBusiness.Auth.autologin()

export const getApplications = () => flBusiness.User.getApplications()

export const getApplicationLogo = () => flBusiness.Application.getLogo()

export const getCallUsers = () => flBusiness.Application.getCallUsers()

export const changeApplication = (application) => flBusiness.Auth.use(application)

export const fetchEntities = () => flBusiness.Entity.getAll()

export const fetchLogout = () => flBusiness.Auth.logout()

export const initCollection = ({id, page, record}) => {
	switch (page) {
		case route.List:
			return flBusiness.Collection.initByList(id)

		case route.Entity:
			return flBusiness.Collection.initByEntity(id)

		case route.Relation:
			return flBusiness.Collection.initByRelation(id, record)

		default:
			console.log()
	}
}

export const setCollectionView = (viewId) => flBusiness.Collection.setView(viewId)

export const setTextFilter = (pattern) => flBusiness.Collection.setTextFilter(pattern)

export const fetchLockCol = ({field}) => flBusiness.Collection.toggleLocked(field)

export const fetchResizeColumn = ({field, width}) => flBusiness.Collection.setFieldWidth(field, width)

export const fetchReorderColumns = ({columns}) => flBusiness.Collection.setFieldsOrder(columns)

export const toggleFieldSort = ({field}) => flBusiness.Collection.toggleFieldSort(field)

export const toggleFieldHide = ({field}) => flBusiness.Collection.toggleFieldHidden(field)

export const setFilters = ({filters, save}) => flBusiness.Collection.setFilters(filters, save)

export const fetchRelations = ({id, pagetype}) => {
	switch (pagetype) {
		case route.Record:
			return flBusiness.Relation.getAll(Number(id))

		case route.Relation:
			return flBusiness.Relation.getSiblings(id)

		default:
			console.log()
	}
}

export const initRecord = ({entity, recordId}) => flBusiness.Record.init(entity, recordId)

export const updateRecord = ({recordId, fieldId, value}) => flBusiness.Record.update(recordId, fieldId, value)

export const duplicateRecord = () => flBusiness.Record.duplicate()

export const deleteRecord = (ids) => flBusiness.Record.delete(ids)

export const fetchRenameEntity = ({name, entity}) => flBusiness.Entity.rename(Number(entity), name)

export const fetchRenameCol = ({name, col}) => flBusiness.Field.rename(col, name)

export const fetchDeleteCol = (col) => flBusiness.Field.delete(col)

export const fetchAddCol = (entity) => flBusiness.Field.create(entity)

export const fetchDocumentAdd = () => flBusiness.Collection.Documents.create()

export const fetchDocumentDelete = ({records}) => flBusiness.Collection.Documents.delete(records)

export const fetchDocumentUpdate = ({record, fieldId, value}) => flBusiness.Collection.Documents.update(record, fieldId, value)

export const fetchDocumentsUpdate = ({records, fieldId, value}) => flBusiness.Collection.Documents.bulkUpdate(records, fieldId, value)

export const fetchLinkedOptions = (id, row, env) => {
	switch (env) {
		case environment.Collection:
			return flBusiness.Collection.getLinkedOptions(id, row)

		case environment.Record:
			return flBusiness.Record.getLinkedOptions(id)

		default:
			return flBusiness.Field.Linked.getOptions(id)
	}
}

export const fetchViews = ({id, page}) => {
	switch (page) {
		case route.List:
			return flBusiness.View.getByListId(id)

		case route.Relation:
			return flBusiness.View.getByRelationId(id)

		default:
			return flBusiness.View.getByListId(id)
	}
}

export const createView = ({config, id}) => flBusiness.View.create(config, id)

export const deleteView = ({viewId}) => flBusiness.View.delete(viewId)

export const toggleIncludeView = ({id, value}) => flBusiness.List.toggleUseGlobal(id, value)

export const updateView = ({config, id}) => flBusiness.View.update(config, id)

export const changeTypeToBasic = ({field, fieldType}) => flBusiness.Field.Promote.toBasic(field, fieldType)

export const changeTypeToComplex = ({field, config, format}) => {
	switch(format) {
		case fieldtype.number:
			return flBusiness.Field.Promote.toNumber(field, config)

		case fieldtype.datetime:
			return flBusiness.Field.Promote.toDatetime(field, config)

		case fieldtype.lookup:
			return flBusiness.Field.Promote.toLookup(field, config)

		case fieldtype.linkedfield:
			return flBusiness.Field.Promote.toLinked(field, config.main, config.filters)

		case fieldtype.phone:
			return flBusiness.Field.Promote.toPhone(field, config)

		case fieldtype.formula:
			return flBusiness.Field.Promote.toFormula(field, config)

		default:
			console.log()
	}
}

export const fetchModules = () => flBusiness.Module.getAll()

export const createModule = (config) => flBusiness.Module.create(config)

export const deleteModule = (id) => flBusiness.Module.delete(id)

export const updateModule = (config) => flBusiness.Module.update(config)

export const changeModule = ({cardId, moduleId}) => flBusiness.Card.changeModule(cardId, moduleId)

export const setApplicationLogo = ({img}) => flBusiness.Application.setLogo(img)

export const setApplicationName = (name) => flBusiness.Application.rename(name)

export const setUserData = (data) => flBusiness.User.setData(data)

export const createCard = ({config, format}) => {
	switch (format) {
		case cards.List:
			return flBusiness.Card.List.create(config)

		case cards.Widget:
			return flBusiness.Card.Widget.create(config)

		case cards.Graphic:
			return flBusiness.Card.Graphic.create(config)

		case cards.Planning:
			return flBusiness.Card.Planning.create(config)

        case cards.Scheduler:
			return flBusiness.Card.Scheduler.create(config)

		default:
			return flBusiness.Card.List.create(config)
	}
}

export const updateCard = ({config, format}) => {
	switch (format) {
		case cards.List:
			return flBusiness.Card.List.update(config)

		case cards.Widget:
			return flBusiness.Card.Widget.update(config)

		case cards.Graphic:
			return flBusiness.Card.Graphic.update(config)
		default:
			console.log()
	}
}

export const deleteCard = async (id) => flBusiness.Card.delete(id)

export const getRollup = (cardId) => flBusiness.Card.getData(cardId)

export const fetchReorderModules = async (order) => flBusiness.Module.setOrder(order)

export const reorderViews = ({id, order}) => flBusiness.List.setViewsOrder(id, order)

export const fetchPlanning = (id) => flBusiness.Planning.get(id)

export const updatePlanning = (config) => flBusiness.Planning.update(config)

export const fetchPlanningData = (id) => flBusiness.Planning.getData(id)

export const setColors = ({id, data}) => flBusiness.Planning.setColors(id, data)

export const eventCreate = (entity, record) => flBusiness.Documents.create(entity, record)

export const eventDelete = (entity, record) => flBusiness.Documents.delete(entity, record)

export const eventUpdate = (entity, record) => flBusiness.Documents.replace(entity, record)

export const createRelation = ({from, to, verb, title}) => flBusiness.Relation.create(from, to, verb, title)

export const updateRelation = ({id, verb}) => flBusiness.Relation.rename(id, verb)

export const getSheets = (file) => flBusiness.Excel.Import.getSheets(file)

export const excelParse = ({multiple, file, entityId, name, moduleId}) => multiple ?
	flBusiness.Excel.Import.parseMultiple(file, moduleId) :
	flBusiness.Excel.Import.parse(file, entityId, name, moduleId)

export const fetchExcelTemplates = (entityId) => flBusiness.Excel.Export.Template.getAll(entityId)

export const exportExcel = ({template, documents}) => flBusiness.Excel.Export.tpl(template, documents)

export const globalExportExcel = () => flBusiness.Excel.Export.global()

export const deleteExcelTemplate = (template) => flBusiness.Excel.Export.Template.delete(template)

export const setDefaultValue = (field, value) => flBusiness.Field.setDefaultValue(field, value)

export const getPublicEnabled = () => flBusiness.Application.getPublicEnabled()

export const fetchPublicTables = (entityId) => flBusiness.PublicTable.getAll(entityId)

export const createPublicTable = (data) => flBusiness.PublicTable.create(data)

export const deletePublicTable = (table) => flBusiness.PublicTable.delete(table)

export const updatePublicTable = (data) => flBusiness.PublicTable.update(data)

export const createPublicForm = (data, notifications) => flBusiness.PublicForm.create(data, notifications)

export const deletePublicForm = (form) => flBusiness.PublicForm.delete(form)

export const updatePublicForm = (data, notifications) => flBusiness.PublicForm.update(data, notifications)

export const createSmsTemplate = (data) => flBusiness.Sms.Template.create(data)

export const deleteSmsTemplate = (form) => flBusiness.Sms.Template.delete(form)

export const updateSmsTemplate = (data) => flBusiness.Sms.Template.update(data)

export const sendSmsTemplate = (template, documents, save, test) => flBusiness.Sms.send(template, documents, save, test)

export const fetchSmsTemplate = (id) => flBusiness.Sms.Template.load(id)

export const createEmailTemplate = (data) => flBusiness.Email.Template.create(data)

export const deleteEmailTemplate = (form) => flBusiness.Email.Template.delete(form)

export const updateEmailTemplate = (data) => flBusiness.Email.Template.update(data)

export const sendEmailTemplate = (template, documents, save, test) => flBusiness.Email.send(template, documents, save, test)

export const fetchEmailTemplate = (id) => flBusiness.Email.Template.load(id)

export const createSender = ({sender, service}) => flBusiness.Application.Sender.create(sender, service)

export const deleteSender = (id) => flBusiness.Application.Sender.delete(id)

export const verifySender = (id) => flBusiness.Application.Sender.verify(id)

export const fetchUsers = () => flBusiness.Application.getUsers()

export const updateUser = (obj) => flBusiness.Application.attachUser(obj)

export const deleteUser = (name) => flBusiness.Application.detachUser(name)

export const setOwner = (name) => flBusiness.Application.setOwner(name)

export const changePassword = (pass) => flBusiness.User.changePassword(pass)

export const fetchSignatures = () => flBusiness.Email.Settings.Signature.loadAll()

export const deleteExportTemplate = (id) => flBusiness.DataExport.Template.delete(id)

export const exportData = ({template, documents}) => flBusiness.DataExport.run(template, documents)

export const deleteEntity = (id) => flBusiness.Entity.delete(id)

export const setFeedback = (id) => flBusiness.Collection.setFeedback(id)

export const deleteKey = (id) => flBusiness.Feedback.deleteKey(id)

export const fetchStatistics = (feedbacks) => flBusiness.Feedback.getDetails(feedbacks)

export const updateSignature = (obj) => flBusiness.Email.Settings.Signature.update(obj)

export const createSignature = (obj) => flBusiness.Email.Settings.Signature.create(obj)

export const deleteSignature = (id) => flBusiness.Email.Settings.Signature.delete(id)

export const getCallUrl = () => flBusiness.User.getCallUrl()

export const setCallUrl = (value) => flBusiness.User.setCallUrl(value)

export const getKeysFeedback = (entity) => flBusiness.Feedback.getKeys(entity)

export const exportPdf = ({file, template, documents}) => flBusiness.PdfTemplate.run(template, documents, file)

export const deletePdfTemplate = (id) => flBusiness.PdfTemplate.delete(id)

export const getNotifications = (formId) => flBusiness.PublicForm.loadNotifications(formId)

export const copyCard = async (id) => flBusiness.Card.clone(id)

export const fetchFilterOptions = (originEntity, foreignEntity) => flBusiness.Field.Linked.getFilterOptions(originEntity, foreignEntity)

export const clonePublicForm = (id) => flBusiness.PublicForm.clone(id)

export const cloneView = (viewId, id) => flBusiness.View.clone(viewId, id)

export const cloneEmailTemplate = (id) => flBusiness.Email.Template.clone(id)

export const deletePlanning = (id) => flBusiness.Planning.delete(id)

export const renameCard = (id, string, card) => card === cards.Planning ?
	flBusiness.Planning.rename(id, string) :
    card === cards.Scheduler ? flBusiness.Scheduler.rename(id, string) :
	flBusiness.List.rename(id, string)

export const toggleReadonly = (fieldId) => flBusiness.Collection.toggleFieldReadonly(fieldId)

export const fetchScheduler = (id) => flBusiness.Scheduler.get(id)

export const updateScheduler = (config) => flBusiness.Scheduler.update(config)

export const fetchSchedulerData = (id) => flBusiness.Scheduler.getData(id)

export const setSchedulerColors = ({id, data}) => flBusiness.Scheduler.setColors(id, data)

export const deleteScheduler = (id) => flBusiness.Scheduler.delete(id)

export const setEmailTemplatesOrder = (entity, order) => flBusiness.Email.Template.setOrder(entity, order)

export const setSmsTemplatesOrder = (entity, order) => flBusiness.Sms.Template.setOrder(entity, order)

export const setExcelTemplatesOrder = (entity, order) => flBusiness.Excel.Export.Template.setOrder(entity, order)

export const setPublicTableTemplatesOrder = (entity, order) => flBusiness.PublicTable.setOrder(entity, order)

export const setPublicFormTemplatesOrder = (entity, order) => flBusiness.PublicForm.setOrder(entity, order)

export const setExportDataTemplatesOrder = (entity, order) => flBusiness.DataExport.Template.setOrder(entity, order)

export const setPdfTemplatesOrder = (entity, order) => flBusiness.PdfTemplate.setOrder(entity, order)

export default {
	getDefaultInstance,
	fetchInstances,
    fetchLogin,
	fetchRegistration,
	getApplications,
	getCallUsers,
	getApplicationLogo,
	fetchEntities,
	fetchLogout,
	initCollection,
	setCollectionView,
	setTextFilter,
	fetchResizeColumn,
	fetchReorderColumns,
	initRecord,
	updateRecord,
	fetchRenameEntity,
	fetchRenameCol,
	fetchLockCol,
	fetchDocumentAdd,
	fetchDocumentDelete,
	fetchDocumentUpdate,
	fetchAutologin,
	changeApplication,
	fetchRelations,
	fetchLinkedOptions,
	fetchDeleteCol,
	fetchAddCol,
	fetchViews,
	createView,
	deleteView,
	updateView,
	toggleFieldSort,
	toggleFieldHide,
	changeTypeToBasic,
	changeTypeToComplex,
	setFilters,
	fetchModules,
	createModule,
	deleteModule,
	updateModule,
	setApplicationLogo,
	setApplicationName,
	setUserData,
	createCard,
	updateCard,
	deleteCard,
	changeModule,
	getRollup,
	fetchReorderModules,
	reorderViews,
	fetchPlanning,
	updatePlanning,
	fetchPlanningData,
	setColors,
	toggleIncludeView,
	eventCreate,
	eventDelete,
	eventUpdate,
	duplicateRecord,
	deleteRecord,
	fetchDocumentsUpdate,
	createRelation,
	updateRelation,
	getSheets,
	excelParse,
	fetchExcelTemplates,
	exportExcel,
	deleteExcelTemplate,
	globalExportExcel,
	setDefaultValue,
	getPublicEnabled,
	fetchPublicTables,
	createPublicTable,
	deletePublicTable,
	updatePublicTable,
	createPublicForm,
	deletePublicForm,
	updatePublicForm,
	createSmsTemplate,
	deleteSmsTemplate,
	updateSmsTemplate,
	sendSmsTemplate,
	fetchSmsTemplate,
	createEmailTemplate,
	deleteEmailTemplate,
	updateEmailTemplate,
	sendEmailTemplate,
	fetchEmailTemplate,
	createSender,
	deleteSender,
	verifySender,
	fetchUsers,
	updateUser,
	deleteUser,
	changePassword,
	fetchSignatures,
	deleteExportTemplate,
	exportData,
	deleteEntity,
	setFeedback,
	deleteKey,
	fetchStatistics,
	updateSignature,
	createSignature,
	deleteSignature,
	getCallUrl,
	setCallUrl,
	getKeysFeedback,
	exportPdf,
	deletePdfTemplate,
	getNotifications,
	copyCard,
	fetchFilterOptions,
	clonePublicForm,
	cloneView,
	cloneEmailTemplate,
	setOwner,
	deletePlanning,
	renameCard,
	toggleReadonly,
    fetchScheduler,
	updateScheduler,
	fetchSchedulerData,
	setSchedulerColors,
    deleteScheduler,
    setEmailTemplatesOrder,
    setSmsTemplatesOrder,
    setExcelTemplatesOrder,
    setPublicTableTemplatesOrder,
    setPublicFormTemplatesOrder,
    setExportDataTemplatesOrder,
    setPdfTemplatesOrder
}
